import React from 'react';

export function SubscriptionExpiredMessage() {
    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="max-w-md text-center rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg p-8">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-100 dark:bg-amber-900/40 mb-4">
                    <i className="ri-error-warning-line text-2xl text-amber-600 dark:text-amber-400" />
                </div>
                <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100">
                    Subscription expired
                </h1>
                <p className="mt-3 text-slate-600 dark:text-slate-300">
                    Subscription for your restaurant has expired. Ask owner to reactivate it.
                </p>
            </div>
        </div>
    );
}
